import { useState } from "react";
import TitleHeader from "../shared/title-header";
import RelationshipSelector from "../shared/RelationshipSelector";
import { InvoiceExportComponent } from "./InvoiceExportComponent";
import RouterHelper from "../utilities/router-helper";
import { useAuth } from "../auth";

interface InvoiceSummaryReportProps {
  routerHelper: RouterHelper;
}

export default function InvoiceSummaryReport({ routerHelper }: InvoiceSummaryReportProps) {
  const auth = useAuth();
  const relationshipId = routerHelper.getRelationshipId() || auth.user.relationshipId;
  const [selectedRelationshipId, setSelectedRelationshipId] = useState<string | number>(relationshipId);

  return (
    <div>
      <TitleHeader title="Invoice Summary Report" />
      <div>
        <RelationshipSelector
          routerHelper={routerHelper}
          nonRoute={true}
          nonRouteCallback={(relationshipId) => setSelectedRelationshipId(relationshipId)}
          nonRouteSelectedRelationshipIdValue={selectedRelationshipId}
        />
      </div>
      {selectedRelationshipId && <InvoiceExportComponent relationshipId={selectedRelationshipId.toString()} />}
    </div>
  );
}
